import React from 'react'

import SmallWidget from 'domains/dashboard/components/SmallWidget'

interface IProps {
  fadeDelay: number
  count: number
}

export default function OrganizationDistrictCountWidget(props: IProps) {
  return (
    <SmallWidget
      flexible="column-h-start"
      fadeDelay={props.fadeDelay}
      icon="fas fa-school"
      iconColor="secondary"
      title={props.count}
      subtitle="Districts"
      dataTest="districts-count-widget"
    />
  )
}
